import { styled, Tab, Tooltip, withStyles } from "@material-ui/core";

export const StyledTab = styled(Tab)({
  textTransform: "none",
  "&:active": {
    outline: "none",
  },
  "&:focus": {
    outline: "none",
  },
  outline: "none",
});

export const StyledTooltip = withStyles((theme) => ({
  popper: {
    boxShadow: "none",
  },
  tooltip: {
    padding: theme.spacing(1),
    margin: 0,

    "& > p": {
      margin: 0,
    },
  },
}))(Tooltip);

export const DropdownContainer = styled("div")({
  width: "30%",
  position: "absolute",
  right: "3rem",
  top: "2rem",
});

export const TooltipContainer = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/SchoolProfileView.styled.js